export default "__VITE_ASSET__CwCZT2XR__"